<app-header></app-header>
<router-outlet></router-outlet>
<app-spinner></app-spinner>
